<template>
  <div>
    <b-modal
      ref="modal-setting-travel-route"
      :title="$t('NEW TOLL GROUP')"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      size="lg"
      no-close-on-backdrop
      no-close-on-esc
    >
      <ValidationObserver ref="toll-group-form">
        <b-row>
          <!-- TOLL GROUP NAME -->
          <b-col cols="6">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required"
              name="group_name"
            >
              <b-form-group
                :label="$t('Toll group name')"
                :state="errors[0] ? false : null"
              >
                <b-form-input
                  type="text"
                  v-model="form.group_name"
                  :class="{ 'border-danger': errors[0] }"
                  @change="validateUniqueName"
                ></b-form-input>
              </b-form-group>
            </ValidationProvider>
          </b-col>

          <!-- TOLLS -->
          <b-col sm="6">
            <b-form-group
              :label="$t('Toll')"
              label-for="toll_id"
              style="margin-top: 5px"
            >
              <v-select
                v-model="toll_id"
                :options="tolls"
                append-to-body
                :calculate-position="positionDropdown"
                :placeholder="`${$t('Select')}...`"
                :reduce="(l) => l.id"
                label="name"
                @input="addToll()"
              />
            </b-form-group>
          </b-col>

          <b-col cols="12">
            <div v-if="tolls.length > 0">
              <b-table :items="tollList" :fields="fields" sticky-header>
                <template #cell(toll_name)="data">
                  <tabler-icon
                  icon="TicketIcon"
                  class="text-warning"
                  />
                  {{ data.item.toll_name }}
                </template>
                <template #cell(toll_amount)="data">
                  S/ {{ parseFloat(data.item.toll_amount).toFixed(2) }}
                </template>
                <template #cell(toll_type)="data">
                  <div :class="data.item.toll_type == 'CASH' ? 'text-success' : 'text-warning'">
                    {{ $t(data.item.toll_type) }}
                  </div>
                </template>
                <template #cell(actions)="data">
                  <feather-icon
                    icon="XIcon"
                    class="text-danger cursor-pointer"
                    @click="removeToll(data.item)"
                  />
                </template>
              </b-table>
            </div>
          </b-col>

          <b-col cols="12" v-if="tollsSelected.length != 0">
            <div class="d-flex justify-content-end">
              <div class=" px-2">
                <strong>{{ $t("Quantity") }}: </strong> {{ quantityTolls }}
              </div>
              <div>
                <strong>Total: </strong> S/ {{ totalToll }}
              </div>
            </div>
          </b-col>
        </b-row>
      </ValidationObserver>
      <template #modal-footer>
        <div class="d-flex justify-content-end">
          <b-button
            @click="registerTollGroup()"
            variant="outline-success"
            :disabled="tollsSelected.length == 0 || !isUniqueName"
            >{{ $t("REGISTER") }}</b-button
          >
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import modalMixin from "@/mixins/modal";
import TravelRoutesService from "@/views/settings/views/travel-routes/services/travel-routes.service.js";
import AutoSuggestAjaxVue from "@/views/forms/form-element/autosuggest/AutoSuggestAjax.vue";

export default {
  mixins: [modalMixin],
  props: {
    tollList: {
      type: Array,
      default: [],
    },
    originId: {
      type: Number,
      default: null,
    },
    destinationId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      form: {
        id: null,
        origin_id: null,
        destination_id: null,
        tolls: 0,
      },
      originRoutes: [],
      destinationRoutes: [],
      tolls: [],
      toll_id: null,
      tollsSelected: [],
      isUniqueName: true,
      fields: [
        { key: "toll_name", label: app.$i18n.t("Name") },
        { key: "toll_amount", label: app.$i18n.t("Amount") },
        { key: "toll_type", label: app.$i18n.t("Type") },
        { key: "actions", label: app.$i18n.t("Actions") },
      ],
    };
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    getTitleModal() {
      if (this.routeId == null) return "NEW ROUTE";
      return "EDIT ROUTE";
    },
    totalToll(){
      let totalAmount = 0;
      this.tollsSelected.forEach(item => {
        totalAmount += parseFloat(item.toll_amount)
      })
      return totalAmount.toFixed(2);
    },
    quantityTolls(){
      return this.tollsSelected.length
    }
  },
  async created() {
    this.tollsSelected = this.tollList;
    await this.getTolls();
  },
  watch: {},
  mounted() {
    this.toggleModal("modal-setting-travel-route");
  },
  methods: {
    async getTolls() {
      const { data } = await TravelRoutesService.getTolls();
      this.tollsCpy = data;
      this.tolls = data.filter((toll) => {
        return !this.tollsSelected.some((list) => toll.id == list.toll_id);
      });
    },
    async validateUniqueName() {
      const form = {
        group_name: this.form.group_name,
      };
      const { data } = await TravelRoutesService.validateUniqueName(form);
      if (!data.isUnique) {
        this.showToastWarning("the name is already in use");
        this.isUniqueName = false;
      } else {
        this.isUniqueName = true;
      }
    },
    async registerTollGroup() {
      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      const params = {
        originId: this.originId,
        destinationId: this.destinationId,
        tolls: this.tollsSelected,
        userId: this.currentUser.employee_id,
        groupName: this.form.group_name,
      };
      const result = await this.$refs["toll-group-form"].validate();
      if (!result) return;
      try {
        this.addPreloader();
        const { data } = await TravelRoutesService.saveTollGroup(params);
        if (data.success) {
          this.showToastSuccess("Successfull process");
          this.$emit("reloadGroups");
          this.$emit("hideModal");
        } else {
          this.showToastError("Error process");
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    resetTollSelector() {
      this.tolls = this.tollsCpy.filter((toll) => {
        return !this.tollsSelected.some((list) => toll.id == list.toll_id);
      });
    },
    addToll() {
      let aux = this.tollsCpy.find((toll) => toll.id == this.toll_id);
      const toll = {
        toll_name: aux.name,
        toll_amount: aux.amount,
        toll_type: aux.type,
        toll_id: aux.id,
      };
      this.tollsSelected.push(toll);
      this.resetTollSelector();
      this.toll_id = null;
    },
    removeToll(item) {
      let index = this.tollsSelected.findIndex(
        (toll) => toll.toll_id == item.toll_id
      );
      this.tollsSelected.splice(index, 1);
      this.resetTollSelector();
    },
    positionDropdown(dropdownList, component, { width, top, left }) {
      dropdownList.style.zIndex = 9999;
      dropdownList.style.maxHeight = "20rem";
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
    },
    hideModal() {
      this.$emit("hideModal");
    },
  },
};
</script>

<style>
</style>